import { render, staticRenderFns } from "./CopyStakeStreamersView.vue?vue&type=template&id=775d08a0&scoped=true&lang=pug"
import script from "./CopyStakeStreamersView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamersView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamersView.vue?vue&type=style&index=0&id=775d08a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d08a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
